
<div class="mock-test-wrapper">
  <div class="left">
    <h1 class="title">11plus Mock Test</h1>
    <h3 class="subtitle">CSSE | FSCE | GL | BUCKS</h3>
    <h4 class="modes">FACE TO FACE | ONLINE | PAPER AT HOME</h4>
    <h4 class="highlight">
      PASS YOUR <span class="orange">11+ EXAM</span> WITH CONFIDENCE
    </h4>
    <p>Signup for our specially designed 11+ Mock Tests!</p>
    <button class="calendar-btn" (click)="scrollToCalendar()">View Calendar</button>
  </div>

  <div class="right">
    <img src="assets/images/target.png" alt="Target Marker" class="target-image">
  </div>
</div>

<div class="cal-inst">

  <h1>Mock Test Calender</h1>
  <h2>SELECT THE DATE/CENTER BELOW & CLICK BOOK BUTTON</h2>

</div>

<marquee class="marquee">
 Focused Boards:  CSSE | FSCE | GL REDBRIDGE | GL KENT | GL BEXLEY | GL QE | GL HBS | BUCKS                  
</marquee>





<!-- CALENDAR STARTS HERE -->

<div class="calendar-container" id="calendar-section">

  <div class="header">
    <div class="mode-buttons">
      <button [class.active]="mode === 'face'" (click)="setMode('face')">Face-2-Face</button>
      <button [class.active]="mode === 'online'" (click)="setMode('online')">Online</button>
    </div>
    <div class="type-buttons">
      <button *ngFor="let type of testTypes"
              [class.active]="selectedType === type"
              (click)="setType(type)">
        {{ type }}
      </button>
    </div>
  </div>

  <div class="month-selector" *ngIf="mode === 'face'">
    <button *ngFor="let month of months"
            [class.active]="selectedMonth === month"
            (click)="selectMonth(month)">
      {{ month }}
    </button>
  </div>

  <div class="scrollable-container">

    <div *ngFor="let group of filteredTests()" class="test-group">

      <div class="test-details">
        <h4>{{ group.category }}</h4>
        <p>{{ group.details }}</p>
      </div>
  
      <div class="test-list">
        <div class="test-card" *ngFor="let test of group.tests">
          <div class="test-info">
            <h5>{{ test.name }}</h5>
            <p >{{ test.date }}</p>
          </div>
  
          <!-- Conditional Rendering -->
          <button *ngIf="mode === 'face'" (click)="openCenterDialog(test)">
            Select Center
          </button>
  
          <button *ngIf="mode === 'online'" (click)="bookOnlineTest(test.bookingUrl)">
            Book
          </button>
        </div>
      </div>
    </div>

  </div>



</div>


<div class="af-ts">

  <h1>With more than a decade of experience we’ve helped <br>
    <strong>10,000+</strong> students improve their scores & ace their <strong>11plus</strong>!</h1>

</div>



<div class="ft-sc">

  <h1>What's Included in Your Mock Test?</h1>

  <div class="ft-sc-info">
    <div class="ft-sc-item left">

      <img src="assets/images/f1.png" alt="">

      <h3>Real Exam Like Environment</h3>
      <p>Timed & structured like actual 11plus Exams</p>
    </div>

    <div class="ft-sc-item">
      <img src="assets/images/f2.png" alt="">
      <h3>Results Analysis Report (RAR)</h3>
      <p>Paper reviewed & marked with comments by 11plus specialist</p>
    </div>

    <div class="ft-sc-item right">
      <img src="assets/images/f3.png" alt="">
      <h3>Take Your Test Paper Home</h3>
      <p>Review your errors & mistakes</p>
    </div>
  </div>

  <div class="ft-sc-info">
    <div class="ft-sc-item left">
      <img src="assets/images/f4.png" alt="">
      <h3>Covers CSSE, FSCE, GL, SET patterns</h3>
      <p>Tailored to your exam board</p>
    </div>

    <div class="ft-sc-item">
      <img src="assets/images/f5.png" alt="">
      <h3>Instant & Detailed Feedback</h3>
      <p>Identify strengths & weaknesses</p>
    </div>

    <div class="ft-sc-item right">
      <img src="assets/images/f6.png" alt="">
      <h3>Consulting & Support </h3>
      <p>Post exam guidance & support from 11plus specialists</p>
    </div>

  </div>

</div>


<div class="co-sc">

  <h1>Join the Community of <br> <span>10K+ Successful Students & Happy Parents!</span></h1>

  <div class="ts-sc">

    <div class="card-ts">

      <h4 style="font-weight: bold;">Jaya Rani</h4>

      <p style="text-align: justify;"> My son did Sehyog Mock Test, it’s very helpful to know which areas my son is lacking. Sehyog result analysis gives us understanding on which area the aspirant/parent needs to improve and concentrate on, which is very important in 11 plus journey, apart from that Sehyog also provides you guidance on how to submit CAF form with the school preferences and clarified most of our doubts. Thank you so much Sehyog team for your all your efforts.</p>


    </div>

    <div class="card-ts">

      <h4 style="font-weight: bold;">harita nagula</h4>

      <p style="text-align: justify;">  Sheyog Mocks really helped my Twins to secure a place in ICHS . Mock exams made my boys have more confidence and follow the timings and instructions. I would recommend to write sheyog mocks to get a real-time experience for the main exam. Thank you Sheyog team for giving us free sessions as I am an NHS staff .
      </p>

      
    </div>

    <div class="card-ts">

      <h4 style="font-weight: bold;">Mini Dagar</h4>

      <p style="text-align: justify;"> My son attended the mock exams by 11plushelpclub and it helped us a lot. With the detailed results every week, we knew which area to work on. Topic wise tests were a great form of revision. All the help by whole team was fabulous which helped my son to secure a safe place at school of his choice. Big thanks to everyone out there for all the help and guidance - Mini Dagar 
      </p>
      
    </div>
    

  </div>

</div>

<div class="faq-sc">

  <h1>FAQs</h1>

  <div class="drop-d">

    <details>
      <summary>How do I book my 11plus Mock Test?</summary>
      <div>
          <p>Select Center and Date on the 11plus Mock Test Calendar and Simply click "Book Now" </p>
          
      </div>
  </details>
  
  <details>
    <summary>Are these tests online or face-to-face?</summary>
    <div>
        <p>We offer both online & offline mock tests. </p>
    </div>
  </details>
  
  <details>
    <summary>Which exam boards do you cover?</summary>
    <div>
        <p>GL, CSSE, FSCE, SET, ISEB – All covered!</p>
    </div>
  </details>

  </div>


  <h3 style="text-align: center; margin-top: 50px;">Still have questions? <br>
    Connect Directly on <strong style="font-weight: bold;">+44 7464772331</strong> & EMAIL <strong style="font-weight: bold;">academy&#64;sehyog.co.uk</strong></h3 >


    <div class="so-sc">

      <img src="assets/images/linkedin.png" alt="linkedin">
      <img src="assets/images/facebook.png" alt="linkedin">
      <img src="assets/images/youtube copy.png" alt="linkedin">
      <img src="assets/images/twitter.png" alt="linkedin">
      <img src="assets/images/instagram.png" alt="linkedin">

    </div>


    <p style="width: 80%; margin-top: 100px; text-align: justify;">SEHYOG is an educational institute dedicated to providing comprehensive support to KS2, 11plus, KS3, 11plus & A-Level students to achieve excellence in education and personal development with honesty and transparency. The sessions, workshops/webinars conducted by SEHYOG do not guarantee 100% success in the real exams. No claim is made as to the accuracy or authenticity of the content of the sessions, workshops/webinars or the information shared via email, website, social media etc. SEHYOG or its volunteers/staff do not accept any liability to any person or firm for the information or advice (or the use of such information or advice) which is provided in the sessions/workshops, email or on social media. The information on the website, phone, emails, social media and sessions/workshops is provided on the basis that all persons accessing the information undertake responsibility for assessing the relevance and accuracy of its content.</p>

 

</div>



<!-- Center Selection Popup -->
<div class="center-popup" *ngIf="showCenterPopup">
  <div class="popup-content">
    <h3>Select Your Center</h3>
    <div class="center-options">
      <button *ngFor="let center of selectedTest?.centers" (click)="selectCenter(center)">
        {{ center.name }}
      </button>
    </div>
    <button class="close-btn" (click)="closeCenterDialog()">Close</button>
  </div>
</div>